import type { SearchResultEvent } from "../api/fetchEventSearchResults/types";

type CompanyStage = { name: string; position: number } | null;

/**
 * The "included with" line on a directory card, mirroring checkout's
 * coverage order (EventSessionSnapshot): the viewer's stage covers events at
 * or below it, and wins over Total Access. Positions compare like for like —
 * both come from the stage table (`companyStage.position` vs the event's
 * indexed `eventStagePosition`).
 */
export function coverageLabel(
  event: Pick<SearchResultEvent, "eventStagePosition" | "isEligibleForLata">,
  companyStage: CompanyStage,
): string | null {
  if (
    companyStage !== null &&
    event.eventStagePosition !== null &&
    companyStage.position >= event.eventStagePosition
  ) {
    return `Included with your ${companyStage.name} membership`;
  }

  return event.isEligibleForLata ? "Included with Total Access" : null;
}
